import { observer } from 'mobx-react-lite'
import { useRouterStore } from '../../../RouterStore'
import { routes } from '../../RouteConfig'
import useStore from 'reusable/mobx-store-utils'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Button from '@mui/material/Button'

export default observer(function AnnouncementXPMSyncErrors() {
   const routerStore = useRouterStore()
   const announcementXPMSyncErrorsStore = useStore(() => ({
      navigateToXpmLog: () => routerStore.navigateToRoute(routes['my-organisation'], 'xpm-log')
   }))

   return <>
      <ErrorOutlineIcon sx={{ mr: 1, color: 'error.dark', fontSize: '20px' }} />
      Sync from Xero Practice Manager completed with errors.
      <Button variant="text" sx={{ ml: 0.5 }} onClick={announcementXPMSyncErrorsStore.navigateToXpmLog}>View logs</Button>
   </>
})
